import { useState, useCallback, useEffect } from 'react';
import { API_BASE } from '../api';

export function useAuth() {
  const [token, setToken] = useState(localStorage.getItem('nas-token'));
  const [username, setUsername] = useState(localStorage.getItem('nas-user'));
  const [userRole, setUserRole] = useState(localStorage.getItem('nas-role') || 'user');
  const [authMode, setAuthMode] = useState('login');
  const [authForm, setAuthForm] = useState({ username: '', password: '' });

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/auth/me`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled || !data?.role) return;
        if (data.role !== localStorage.getItem('nas-role')) {
          localStorage.setItem('nas-role', data.role);
          setUserRole(data.role);
        }
      } catch { /* keep stored role */ }
    })();
    return () => { cancelled = true; };
  }, [token]);

  const handleAuth = useCallback(async (e) => {
    e.preventDefault();
    const endpoint = authMode === 'login' ? '/api/auth/login' : '/api/auth/register';
    try {
      const res = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(authForm)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Auth failed');
      if (authMode === 'login') {
        setToken(data.token);
        setUsername(data.username);
        setUserRole(data.role || 'user');
        localStorage.setItem('nas-token', data.token);
        localStorage.setItem('nas-user', data.username);
        localStorage.setItem('nas-role', data.role || 'user');
      } else {
        setAuthMode('login');
        alert('Registration successful! Please log in.');
      }
    } catch (err) {
      alert(err.message);
    }
  }, [authMode, authForm]);

  const handleLogout = useCallback(() => {
    setToken(null);
    setUsername(null);
    setUserRole('user');
    localStorage.removeItem('nas-token');
    localStorage.removeItem('nas-user');
    localStorage.removeItem('nas-role');
  }, []);

  const isAdmin = userRole === 'admin';

  return {
    token, username, userRole, isAdmin,
    authMode, setAuthMode, authForm, setAuthForm,
    handleAuth, handleLogout
  };
}
